const { makeStyles } = require('@material-ui/core');

export const useAvatarStyles = makeStyles((theme) => ({
  default: {
    color: theme.palette.secondary.contrastText,
  },
}));
